export type Role = string;

export const IS_AUTHENTICATED_ROLE = 'IS_AUTHENTICATED';

export type RolesMap = {
  [key: string]: Role[];
};
